var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLogoApplyAll = function SvgIconLogoApplyAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd",
    clipPath: "url(#icon_logo_applyAll_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7c0-.162.13-.292.292-.292h13.416a.292.292 0 1 1 0 .583H.292A.29.29 0 0 1 0 6.999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.085 7.207a.29.29 0 0 1 0-.413l2.917-2.916a.292.292 0 0 1 .413.412L.705 7l2.71 2.711a.292.292 0 0 1-.413.413zM10.585 10.124a.29.29 0 0 1 0-.413l2.71-2.71-2.71-2.71a.292.292 0 1 1 .413-.413l2.917 2.916a.29.29 0 0 1 0 .413l-2.917 2.917a.29.29 0 0 1-.413 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_logo_applyAll_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 14V0h14v14z"
  })))));
};
export default SvgIconLogoApplyAll;